module.exports = __webpack_public_path__ + "img/bridge1.a4835095.png";